export const RESIZE_ICON_PROPS = {
  view: 'ghost',
  size: 's',
} as const
